/* global $ */
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';

const PersonalInteractionEvaluation = () => {
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [newRecord, setNewRecord] = useState({
        reg_form: "Fresh",
        candidate_type: "",
        training_atten_date: "",
        training_date: "",
        batch_no: "",
        training_title: "",
        sr_no: "",
        organization: "",
        work_location: "",
        incharge: "",
        sub_contractor: "",
        evaluation_option: "",
        payment_made_by: "",
        contract_number: "",
        passport_size: "",
        stamp_size: "",
        Name: "",
        designation: "",
        contact_no: "",
        qualification: "",
        date_of_birth: "",
        languages_known: "",
        total_year_exp: "",
        current_employer: "",
        LMV_HMV_license_no: "",
        types_of_cranes_handled: "",
        marital_status: "",
        fees_amount: "",
        present_address: "",
        permanent_address: "",
        pre_evaluation_test: "",
        service_tax: "",
        license_valid_from: "",
        license_valid_to: "",
        amount_status: "",
        checked_by: "",
        verify_by: "",
        trainers_name: "",
        training_module: "",
        trainers: "",
        training_facility: "",
        learn_something: "",
        learn_something_remark: "",
        about_food: "",
        recommend_colleague: "",
        recommend_colleague_remark: "",
        your_valuable_suggestions: "",
        exp_com1: "",
        exp_year1: "",
        exp_com2: "",
        exp_com3: "",
        exp_year3: "",
        years_as_helper: "",
        years_as_operator: "",
        mini_capa: "",
        max_capa: "",
        version_level: "",
        accidents_occured: "",
        safety_sys: "",
        safety_remark: "",
        work_safety: "",
        work_remark: "",
        loadchart_grade: "",
        loadchart_remark: "",
        signals_grade: "",
        signal_remark: "",
        pre_operational_grade: "",
        pre_operational_remark: "",
        practical_opt_grade: "",
        practical_opt_remark: "",
        evaluate_remark: "",
        interaction: "",
        attentive: "",
        attitude: "",
        evaluated_by: "",
        evaluated_date: "",
    });
    const [searchText, setSearchText] = useState('');
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatchNo, setSelectedBatchNo] = useState('');

    useEffect(() => {
        const fetchBatchNumbers = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');

                // Extract unique batch numbers for the dropdown
                const uniqueBatchNumbers = [...new Set(response.data.map(item => item.batch_no))];
                setBatchNumbers(uniqueBatchNumbers);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchBatchNumbers();
    }, []);

    const convertToYYYYMMDD = (dateStr) => {
        const date = new Date(dateStr);
        if (isNaN(date)) return ""; // Return empty if date is invalid
        return date.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
    };

    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date);
    };

    const handleView = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to view this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, view it!',
        });


        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                reg_form: row.reg_form,
                candidate_type: row.candidate_type,
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                batch_no: row.batch_no,
                training_title: row.training_title,
                sr_no: row.sr_no,
                organization: row.organization,
                work_location: row.work_location,
                incharge: row.incharge,
                sub_contractor: row.sub_contractor,
                evaluation_option: row.evaluation_option,
                payment_made_by: row.payment_made_by,
                contract_number: row.contract_number,
                passport_size: row.passport_size,
                stamp_size: row.stamp_size,
                Name: row.Name,
                designation: row.designation,
                contact_no: row.contact_no,
                qualification: row.qualification,
                date_of_birth: isValidDate(new Date(row.date_of_birth)) ? convertToYYYYMMDD(row.date_of_birth) : "",
                languages_known: row.languages_known,
                total_year_exp: row.total_year_exp,
                current_employer: row.current_employer,
                LMV_HMV_license_no: row.LMV_HMV_license_no,
                types_of_cranes_handled: row.types_of_cranes_handled,
                marital_status: row.marital_status,
                fees_amount: row.fees_amount,
                present_address: row.present_address,
                permanent_address: row.permanent_address,
                pre_evaluation_test: row.pre_evaluation_test,
                service_tax: row.service_tax,
                license_valid_from: isValidDate(new Date(row.license_valid_from)) ? convertToYYYYMMDD(row.license_valid_from) : "",
                license_valid_to: isValidDate(new Date(row.license_valid_to)) ? convertToYYYYMMDD(row.license_valid_to) : "",
                amount_status: row.amount_status,
                checked_by: row.checked_by,
                verify_by: row.verify_by,
                trainers_name: row.trainers_name,
                training_module: row.training_module,
                trainers: row.trainers,
                training_facility: row.training_facility,
                learn_something: row.learn_something,
                learn_something_remark: row.learn_something_remark,
                about_food: row.about_food,
                recommend_colleague: row.recommend_colleague,
                recommend_colleague_remark: row.recommend_colleague_remark,
                your_valuable_suggestions: row.your_valuable_suggestions,
                feedback_status: row.feedback_status,
                exp_com1: row.exp_com1,
                exp_year1: row.exp_year1,
                exp_com2: row.exp_com2,
                exp_year2: row.exp_year2,
                exp_com3: row.exp_com3,
                exp_year3: row.exp_year3,
                years_as_helper: row.years_as_helper,
                years_as_operator: row.years_as_operator,
                mini_capa: row.mini_capa,
                max_capa: row.max_capa,
                version_level: row.version_level,
                accidents_occured: row.accidents_occured,
                safety_sys: row.safety_sys,
                safety_remark: row.safety_remark,
                work_safety: row.work_safety,
                work_remark: row.work_remark,
                loadchart_grade: row.loadchart_grade,
                loadchart_remark: row.loadchart_remark,
                signals_grade: row.signals_grade,
                signal_remark: row.signal_remark,
                pre_operational_grade: row.pre_operational_grade,
                pre_operational_remark: row.pre_operational_remark,
                practical_opt_grade: row.practical_opt_grade,
                practical_opt_remark: row.practical_opt_remark,
                evaluate_remark: row.evaluate_remark,
                interaction: row.interaction,
                attentive: row.attentive,
                attitude: row.attitude,
                evaluated_by: row.evaluated_by,
                evaluated_date: row.evaluated_date && isValidDate(new Date(row.evaluated_date)) ? convertToYYYYMMDD(row.evaluated_date) : "",
            });
            $('#viewRowModal').modal('show');
        }
    };

    const handlePrint = (row) => {
        const printWindow = window.open('', '_blank');
        const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Personal Interaction Evaluation - ${row.Name}</title>
            <style>
                @page {
                    size: A4;
                    margin: 10mm;
                }
                * { box-sizing: border-box; }
                html, body {
                    margin: 0;
                    padding: 0;
                }
                body {
                    font-family: Arial, sans-serif;
                    font-size: 13px;
                    line-height: 1.35;
                    color: #000;
                }
                /* A4 (297mm) minus 10mm top/bottom page margins */
                .page {
                    display: flex;
                    flex-direction: column;
                    min-height: 275mm;
                }
                .content {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }
                .header {
                    text-align: center;
                    margin-bottom: 14px;
                    border-bottom: 2px solid #000;
                    padding-bottom: 8px;
                }
                .header h1 {
                    margin: 0;
                    font-size: 22px;
                    color: #000;
                    font-weight: bold;
                }
                .header p {
                    margin: 4px 0 0;
                    font-size: 12px;
                    color: #000;
                }
                .section {
                    margin-bottom: 12px;
                    page-break-inside: avoid;
                }
                .section-title {
                    background-color: #000;
                    color: white;
                    padding: 5px 10px;
                    font-weight: bold;
                    font-size: 14px;
                    margin-bottom: 8px;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                .info-row {
                    display: flex;
                    margin-bottom: 6px;
                    align-items: flex-start;
                }
                .info-label {
                    font-weight: bold;
                    width: 140px;
                    flex-shrink: 0;
                    color: #000;
                    font-size: 13px;
                }
                .info-value {
                    flex: 1;
                    color: #000;
                    font-size: 13px;
                }
                .two-column {
                    display: flex;
                    gap: 18px;
                }
                .column {
                    flex: 1;
                }
                .signatures {
                    display: flex;
                    justify-content: space-between;
                    gap: 30px;
                    margin-top: 20px;
                    padding-top: 60px;
                    page-break-inside: avoid;
                }
                .sign-block {
                    flex: 1;
                    text-align: center;
                }
                .sign-line {
                    border-top: 2px dotted #000;
                    margin-bottom: 6px;
                }
                .sign-label {
                    font-weight: bold;
                    font-size: 13px;
                }
                .printed-on {
                    margin-top: 14px;
                    text-align: center;
                    font-size: 10px;
                    color: #000;
                }
            </style>
        </head>
        <body>
            <div class="page">
            <div class="header">
                <h1>PERSONAL INTERACTION EVALUATION REPORT</h1>
                <p>Date: ${new Date().toLocaleDateString()}</p>
            </div>

            <div class="content">
            <div class="section">
                <div class="section-title">Basic Information</div>
                <div class="two-column">
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Name:</div>
                            <div class="info-value">${row.Name || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Batch No:</div>
                            <div class="info-value">${row.batch_no || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Registration No:</div>
                            <div class="info-value">${row.sr_no || 'N/A'}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Training Date:</div>
                            <div class="info-value">${row.training_date ? convertToYYYYMMDD(row.training_date) : 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Training Title:</div>
                            <div class="info-value">${row.training_title || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">License No:</div>
                            <div class="info-value">${row.LMV_HMV_license_no || 'N/A'}</div>
                        </div>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-label">Organization:</div>
                    <div class="info-value">${row.organization || 'N/A'}</div>
                </div>
            </div>

            <div class="section">
                <div class="section-title">Experience Details</div>
                <div class="two-column">
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Company 1:</div>
                            <div class="info-value">${row.exp_com1 || 'N/A'} (${row.exp_year1 || 'N/A'} yrs)</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Company 2:</div>
                            <div class="info-value">${row.exp_com2 || 'N/A'} (${row.exp_year2 || 'N/A'} yrs)</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Company 3:</div>
                            <div class="info-value">${row.exp_com3 || 'N/A'} (${row.exp_year3 || 'N/A'} yrs)</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Years as Helper:</div>
                            <div class="info-value">${row.years_as_helper || 'N/A'}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Years as Operator:</div>
                            <div class="info-value">${row.years_as_operator || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Min Capacity:</div>
                            <div class="info-value">${row.mini_capa || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Max Capacity:</div>
                            <div class="info-value">${row.max_capa || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Version Level:</div>
                            <div class="info-value">${row.version_level || 'N/A'}</div>
                        </div>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-label">Accidents Occurred:</div>
                    <div class="info-value">${row.accidents_occured || 'N/A'}</div>
                </div>
            </div>

            <div class="section">
                <div class="section-title">Area Analyzed</div>
                <div class="two-column">
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Safety Systems:</div>
                            <div class="info-value">${row.safety_sys || 'N/A'} - ${row.safety_remark || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Work Systems:</div>
                            <div class="info-value">${row.work_safety || 'N/A'} - ${row.work_remark || 'N/A'}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Load Chart:</div>
                            <div class="info-value">${row.loadchart_grade || 'N/A'} - ${row.loadchart_remark || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Signals:</div>
                            <div class="info-value">${row.signals_grade || 'N/A'} - ${row.signal_remark || 'N/A'}</div>
                        </div>
                    </div>
                </div>
                <div class="two-column">
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Pre-Operational:</div>
                            <div class="info-value">${row.pre_operational_grade || 'N/A'} - ${row.pre_operational_remark || 'N/A'}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Practical Operation:</div>
                            <div class="info-value">${row.practical_opt_grade || 'N/A'} - ${row.practical_opt_remark || 'N/A'}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="section-title">Personal Assessment</div>
                <div class="two-column">
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Interaction:</div>
                            <div class="info-value">${row.interaction || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Attentive:</div>
                            <div class="info-value">${row.attentive || 'N/A'}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Attitude:</div>
                            <div class="info-value">${row.attitude || 'N/A'}</div>
                        </div>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-label">Remark:</div>
                    <div class="info-value">${row.evaluate_remark || 'N/A'}</div>
                </div>
            </div>

            <div class="section">
                <div class="section-title">Final Evaluation</div>
                <div class="two-column">
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Final Grade:</div>
                            <div class="info-value">${row.final_grade || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Status:</div>
                            <div class="info-value">${row.evaluate_grade_status || 'N/A'}</div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="info-row">
                            <div class="info-label">Evaluated By:</div>
                            <div class="info-value">${row.evaluated_by || 'N/A'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-label">Evaluation Date:</div>
                            <div class="info-value">${row.evaluated_date ? convertToYYYYMMDD(row.evaluated_date) : 'N/A'}</div>
                        </div>
                    </div>
                </div>
            </div>

            </div>

            <div class="signatures">
                <div class="sign-block">
                    <div class="sign-line"></div>
                    <div class="sign-label">Checked by</div>
                </div>
                <div class="sign-block">
                    <div class="sign-line"></div>
                    <div class="sign-label">Verified by</div>
                </div>
                <div class="sign-block">
                    <div class="sign-line"></div>
                    <div class="sign-label">Authorized by</div>
                </div>
            </div>
            <div class="printed-on">Printed on: ${new Date().toLocaleString()}</div>
            </div>

            <script>
                window.onload = function() {
                    window.print();
                    window.onafterprint = function() {
                        window.close();
                    };
                };
            </script>
        </body>
        </html>
            `;

        printWindow.document.write(printContent);
        printWindow.document.close();
    };

    const handleEdit = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to edit this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
        });


        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                reg_form: row.reg_form,
                candidate_type: row.candidate_type,
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                batch_no: row.batch_no,
                training_title: row.training_title,
                sr_no: row.sr_no,
                organization: row.organization,
                work_location: row.work_location,
                incharge: row.incharge,
                sub_contractor: row.sub_contractor,
                evaluation_option: row.evaluation_option,
                payment_made_by: row.payment_made_by,
                contract_number: row.contract_number,
                passport_size: row.passport_size,
                stamp_size: row.stamp_size,
                Name: row.Name,
                designation: row.designation,
                contact_no: row.contact_no,
                qualification: row.qualification,
                date_of_birth: isValidDate(new Date(row.date_of_birth)) ? convertToYYYYMMDD(row.date_of_birth) : "",
                languages_known: row.languages_known,
                total_year_exp: row.total_year_exp,
                current_employer: row.current_employer,
                LMV_HMV_license_no: row.LMV_HMV_license_no,
                types_of_cranes_handled: row.types_of_cranes_handled,
                marital_status: row.marital_status,
                fees_amount: row.fees_amount,
                present_address: row.present_address,
                permanent_address: row.permanent_address,
                pre_evaluation_test: row.pre_evaluation_test,
                service_tax: row.service_tax,
                license_valid_from: isValidDate(new Date(row.license_valid_from)) ? convertToYYYYMMDD(row.license_valid_from) : "",
                license_valid_to: isValidDate(new Date(row.license_valid_to)) ? convertToYYYYMMDD(row.license_valid_to) : "",
                amount_status: row.amount_status,
                checked_by: row.checked_by,
                verify_by: row.verify_by,
                trainers_name: row.trainers_name,
                training_module: row.training_module,
                trainers: row.trainers,
                training_facility: row.training_facility,
                learn_something: row.learn_something,
                learn_something_remark: row.learn_something_remark,
                about_food: row.about_food,
                recommend_colleague: row.recommend_colleague,
                recommend_colleague_remark: row.recommend_colleague_remark,
                your_valuable_suggestions: row.your_valuable_suggestions,
                feedback_status: row.feedback_status,
                exp_com1: row.exp_com1,
                exp_year1: row.exp_year1,
                exp_com2: row.exp_com2,
                exp_year2: row.exp_year2,
                exp_com3: row.exp_com3,
                exp_year3: row.exp_year3,
                years_as_helper: row.years_as_helper,
                years_as_operator: row.years_as_operator,
                mini_capa: row.mini_capa,
                max_capa: row.max_capa,
                version_level: row.version_level,
                accidents_occured: row.accidents_occured,
                safety_sys: row.safety_sys,
                safety_remark: row.safety_remark,
                work_safety: row.work_safety,
                work_remark: row.work_remark,
                loadchart_grade: row.loadchart_grade,
                loadchart_remark: row.loadchart_remark,
                signals_grade: row.signals_grade,
                signal_remark: row.signal_remark,
                pre_operational_grade: row.pre_operational_grade,
                pre_operational_remark: row.pre_operational_remark,
                practical_opt_grade: row.practical_opt_grade,
                practical_opt_remark: row.practical_opt_remark,
                evaluate_remark: row.evaluate_remark,
                interaction: row.interaction,
                attentive: row.attentive,
                attitude: row.attitude,
                evaluated_by: row.evaluated_by,
                evaluated_date: row.evaluated_date && isValidDate(new Date(row.evaluated_date)) ? convertToYYYYMMDD(row.evaluated_date) : "",
            });
            $('#editRowModal').modal('show');
        }
    };

    // const calculateFinalGrade = (record) => {
    //     const safetySys = parseFloat(record.safety_sys) || 0;
    //     const workSafety = parseFloat(record.work_safety) || 0;
    //     const loadchartGrade = record.loadchart_grade === 'N/A' ? null : parseFloat(record.loadchart_grade);
    //     const signalsGrade = parseFloat(record.signals_grade) || 0;
    //     const preOperationalGrade = parseFloat(record.pre_operational_grade) || 0;
    //     const practicalOptGrade = parseFloat(record.practical_opt_grade) || 0;

    //     let total, average;
    //     if (loadchartGrade === null) {
    //         total = safetySys + workSafety + signalsGrade + preOperationalGrade + practicalOptGrade;
    //         average = Math.round(total / 5);
    //     } else {
    //         total = safetySys + workSafety + loadchartGrade + signalsGrade + preOperationalGrade + practicalOptGrade;
    //         average = Math.round(total / 6);
    //     }

    //     let grade = '';
    //     let status = '';
    //     if (average === 10) {
    //         grade = 'A+';
    //         status = 'Pass';
    //     } else if (average === 8 || average === 9) {
    //         grade = 'A';
    //         status = 'Pass';
    //     } else if (average === 6 || average === 7) {
    //         grade = 'B';
    //         status = 'Pass';
    //     } else if (average === 5) {
    //         grade = 'C';
    //         status = 'Pass';
    //     } else if (average < 5) {
    //         grade = 'F';
    //         status = 'Fail';
    //     }

    //     return {
    //         final_grade1: average,
    //         finalgrade2: grade,
    //         evaluate_grade_status: status,
    //         overal_perform: average
    //     };
    // };


    const calculateFinalGrade = (record) => {
        // helper: parse a grade string to a finite number or return null if invalid/N/A
        const parseGrade = (v) => {
            if (v === null || v === undefined) return null;
            const s = String(v).trim();
            if (s.length === 0) return null;
            if (s.toUpperCase() === 'N/A') return null;
            // remove any non-number trailing like "8/10" -> parseFloat will handle "8"
            const n = parseFloat(s);
            return Number.isFinite(n) ? n : null;
        };

        const grades = [
            parseGrade(record.safety_sys),
            parseGrade(record.work_safety),
            parseGrade(record.loadchart_grade),
            parseGrade(record.signals_grade),
            parseGrade(record.pre_operational_grade),
            parseGrade(record.practical_opt_grade)
        ];

        // count only included (non-null) grades
        const included = grades.filter(g => g !== null);
        const count = included.length;

        // If nothing valid, return zeros/fail-safe
        if (count === 0) {
            return {
                total: 0,
                count: 0,
                final_grade1: 0,
                finalgrade2: 'F',
                evaluate_grade_status: 'Fail',
                overal_perform: 0
            };
        }

        const total = included.reduce((s, x) => s + x, 0);
        const average = Math.round(total / count); // matches PHP round(...,0)

        // determine letter grade
        let grade = '';
        let status = '';
        if (average === 10) {
            grade = 'A+';
            status = 'Pass';
        } else if (average === 8 || average === 9) {
            grade = 'A';
            status = 'Pass';
        } else if (average === 6 || average === 7) {
            grade = 'B';
            status = 'Pass';
        } else if (average === 5) {
            grade = 'C';
            status = 'Pass';
        } else { // < 5
            grade = 'F';
            status = 'Fail';
        }

        return {
            total,
            count,
            final_grade1: average,
            finalgrade2: grade,
            evaluate_grade_status: status,
            overal_perform: average
        };
    };


    const handleFormSubmit = async (event) => {
        event.preventDefault();

        if (!selectedRow) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to save the changes?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, save it!'
        });

        if (result.isConfirmed) {

            // Calculate the grades
            const gradeResults = calculateFinalGrade(newRecord);

            const updatedData = {
                mas_id: selectedRow.mas_id,
                exp_com1: newRecord.exp_com1,
                exp_year1: newRecord.exp_year1,
                exp_com2: newRecord.exp_com2,
                exp_year2: newRecord.exp_year2,
                exp_com3: newRecord.exp_com3,
                exp_year3: newRecord.exp_year3,
                years_as_helper: newRecord.years_as_helper,
                years_as_operator: newRecord.years_as_operator,
                mini_capa: newRecord.mini_capa,
                max_capa: newRecord.max_capa,
                version_level: newRecord.version_level,
                accidents_occured: newRecord.accidents_occured,
                safety_sys: newRecord.safety_sys,
                safety_remark: newRecord.safety_remark,
                work_safety: newRecord.work_safety,
                work_remark: newRecord.work_remark,
                loadchart_grade: newRecord.loadchart_grade,
                loadchart_remark: newRecord.loadchart_remark,
                signals_grade: newRecord.signals_grade,
                signal_remark: newRecord.signal_remark,
                pre_operational_grade: newRecord.pre_operational_grade,
                pre_operational_remark: newRecord.pre_operational_remark,
                practical_opt_grade: newRecord.practical_opt_grade,
                practical_opt_remark: newRecord.practical_opt_remark,
                evaluate_remark: newRecord.evaluate_remark,
                interaction: newRecord.interaction,
                attentive: newRecord.attentive,
                attitude: newRecord.attitude,
                evaluated_by: newRecord.evaluated_by,
                evaluated_date: newRecord.evaluated_date,
                final_grade: gradeResults.finalgrade2,
                evaluate_grade_status: gradeResults.evaluate_grade_status,
                overal_perform: gradeResults.overal_perform,
            };

            try {
                await axios.put(`https://api.eazyworldehsengineering.com/api/candidate_registration/${selectedRow.mas_id}`, updatedData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                //setData(data.map(item => item.mas_id === selectedRow.mas_id ? updatedData : item));
                setData(data.map(item =>
                    item.mas_id === selectedRow.mas_id
                        ? { ...item, ...updatedData }
                        : item
                ));

                $('#editRowModal').modal('hide');
                Swal.fire('Saved!', 'The record has been updated.', 'success');
            } catch (error) {
                console.error('Error updating data:', error);
                Swal.fire('Error!', 'There was an issue updating the record.', 'error');
            }
        }
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;

        // Create a new object to update the state correctly
        const updatedRecord = { ...newRecord, [id]: value };

        // Update the state with the new record
        setNewRecord(updatedRecord);
    };

    const handleViewButtonClick = async () => {
        if (!selectedBatchNo) {
            Swal.fire('Error!', 'Please select a batch number.', 'error');
            return;
        }

        try {
            const response = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/evaluation/?batch_no=${selectedBatchNo}`);
            setData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire('Error!', 'There was an issue fetching the data.', 'error');
        }
    };

    const handleResetButtonClick = () => {
        setSelectedBatchNo(''); // Clear dropdown selection
        setData([]); // Clear DataTable data
    };

    const filteredData = data.filter(item => {
        return (
            (item.batch_no && item.batch_no.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.sr_no && item.sr_no.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.Name && item.Name.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.training_title && item.training_title.toLowerCase().includes(searchText.toLowerCase()))
        );
    });


    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '70px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch No</span>,
            selector: row => row.batch_no,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>R.No</span>,
            selector: row => row.sr_no,
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Name</span>,
            selector: row => row.Name,
            width: '200px',
            wrap: true, // You can use this to wrap text
            cell: row => (
                <div style={{ fontWeight: '500', whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                    {row.Name}
                </div>
            ),
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Training Title</span>,
            selector: row => row.training_title,
            width: '200px',
            sortable: true,
            wrap: true, // You can use this to wrap text
            cell: row => (
                <div style={{ fontWeight: '500', whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                    {row.training_title}
                </div>
            ),
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Final Grade</span>,
            selector: row => row.final_grade,
            width: '150px',
            sortable: true,
            wrap: true, // You can use this to wrap text
            cell: row => (
                <div style={{ fontWeight: '500', whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                    {row.final_grade}
                </div>
            ),
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Status</span>,
            selector: row => row.evaluate_grade_status,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Action</span>,
            cell: row => (
                <div className="gap-2">
                    <button className="btn btn-primary btn-sm me-2 mr-2" onClick={() => handleView(row)}>
                        <i className="fa fa-search"></i>
                    </button>
                    <button className="btn btn-primary btn-sm me-2 mr-2" onClick={() => handleEdit(row)}>
                        <i className="fa fa-edit"></i>
                    </button>
                    <button className="btn btn-success btn-sm me-2 mr-2" onClick={() => handlePrint(row)} title="Print">
                        <i className="fa fa-print"></i>
                    </button>
                </div>
            ),
            width: '150px',
            ignoreRowClick: true,
            allowoverflow: true,
        }
    ];

    return (

        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Personal Interaction Evaluation</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Personal Interaction Evaluation</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filter Panel */}
            <div className="row mb-2">
                <div className="col-md-12">
                    <div className="card card-primary card-outline">
                        <div className="card-header">
                            <h5 className="card-title">
                                <i className="fas fa-filter mr-2"></i> Filter by Batch
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="form-row align-items-end">
                                <div className="form-group col-md-3"></div>

                                <div className="form-group col-md-3">
                                    <label>Select Batch Number</label>
                                    <select
                                        id="batchNumber"
                                        className="form-control"
                                        value={selectedBatchNo}
                                        onChange={(e) => setSelectedBatchNo(e.target.value)}
                                    >
                                        <option value="">Select a batch number</option>
                                        {batchNumbers.map((batchNo) => (
                                            <option key={batchNo} value={batchNo}>{batchNo}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group col-md-3 d-flex gap-2">
                                    <button className="btn btn-primary mr-2" onClick={handleViewButtonClick}>
                                        <i className="fas fa-eye mr-1"></i> View
                                    </button>
                                    <button className="btn btn-secondary" onClick={handleResetButtonClick}>
                                        <i className="fas fa-redo mr-1"></i> Reset
                                    </button>
                                </div>

                                <div className="form-group col-md-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Search & Table */}
            <div className="row">
                <div className="col-12">
                    <div className="card card-info card-outline">
                        <div className="card-header">
                            <h5 className="card-title">
                                <i className="fas fa-table mr-2"></i> Evaluation Results
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control mb-3"
                                />
                            </div>

                            <div className="table-responsive">
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    paginationPerPage={100}
                                    paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                    highlightOnHover
                                    striped
                                    className="table table-bordered table-hover"
                                />

                                {/* Edit Modal */}
                                <div className="modal fade" id="editRowModal" tabIndex="-1" role="dialog" aria-hidden="true">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary">
                                                <h5 className="modal-title">Edit Personal Interaction Evaluation</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleFormSubmit}>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>Name</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.Name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>Training Date</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.training_date}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>Organization</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.organization}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>Batch No</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.batch_no}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>License No</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.LMV_HMV_license_no}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-section">
                                                        <hr></hr>
                                                        <h4>Experience</h4>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Company 1</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="exp_com1"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.exp_com1}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Years</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="exp_year1"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.exp_year1}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Company 2</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="exp_com2"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.exp_com2}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Years</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="exp_year2"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.exp_year2}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Company 3</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="exp_com3"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.exp_com3}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Years</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="exp_year3"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.exp_year3}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Years As Helper</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="years_as_helper"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.years_as_helper}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>years as Operator </h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="years_as_operator"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.years_as_operator}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Minimum Capacity</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="mini_capa"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.mini_capa}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Maximum Capacity</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="max_capa"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.max_capa}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Version Level</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="version_level"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.version_level}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Any Accidents occured</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="accidents_occured"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.accidents_occured}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-section">
                                                        <hr></hr>
                                                        <h4>Area Analyzed</h4>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Safety Systems</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="safety_sys"
                                                                        className="form-control select2"
                                                                        value={newRecord.safety_sys}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                        <option value="5">5</option>
                                                                        <option value="6">6</option>
                                                                        <option value="7">7</option>
                                                                        <option value="8">8</option>
                                                                        <option value="9">9</option>
                                                                        <option value="10">10</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="safety_remark"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.safety_remark}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Work Systems</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="work_safety"
                                                                        className="form-control select2"
                                                                        value={newRecord.work_safety}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                        <option value="5">5</option>
                                                                        <option value="6">6</option>
                                                                        <option value="7">7</option>
                                                                        <option value="8">8</option>
                                                                        <option value="9">9</option>
                                                                        <option value="10">10</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="work_remark"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.work_remark}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-section">
                                                        <hr></hr>
                                                        <h4>Understanding Of</h4>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Load Chart</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="loadchart_grade"
                                                                        className="form-control select2"
                                                                        value={newRecord.loadchart_grade}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="NA">NA</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                        <option value="5">5</option>
                                                                        <option value="6">6</option>
                                                                        <option value="7">7</option>
                                                                        <option value="8">8</option>
                                                                        <option value="9">9</option>
                                                                        <option value="10">10</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="loadchart_remark"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.loadchart_remark}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Signals</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="signals_grade"
                                                                        className="form-control select2"
                                                                        value={newRecord.signals_grade}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                        <option value="5">5</option>
                                                                        <option value="6">6</option>
                                                                        <option value="7">7</option>
                                                                        <option value="8">8</option>
                                                                        <option value="9">9</option>
                                                                        <option value="10">10</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="signal_remark"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.signal_remark}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Practical Operation</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="practical_opt_grade"
                                                                        className="form-control select2"
                                                                        value={newRecord.practical_opt_grade}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="1">1</option>
                                                                        <option value="2">2</option>
                                                                        <option value="3">3</option>
                                                                        <option value="4">4</option>
                                                                        <option value="5">5</option>
                                                                        <option value="6">6</option>
                                                                        <option value="7">7</option>
                                                                        <option value="8">8</option>
                                                                        <option value="9">9</option>
                                                                        <option value="10">10</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="practical_opt_remark"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.practical_opt_remark}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <textarea
                                                                        id="evaluate_remark"
                                                                        type="textarea"
                                                                        className="form-control"
                                                                        value={newRecord.evaluate_remark}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Interaction</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="interaction"
                                                                        className="form-control select2"
                                                                        value={newRecord.interaction}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="A">A</option>
                                                                        <option value="A+">A+</option>
                                                                        <option value="B">B</option>
                                                                        <option value="B+">B+</option>
                                                                        <option value="C">C</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Attentive</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="attentive"
                                                                        className="form-control select2"
                                                                        value={newRecord.attentive}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="A">A</option>
                                                                        <option value="A+">A+</option>
                                                                        <option value="B">B</option>
                                                                        <option value="B+">B+</option>
                                                                        <option value="C">C</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Attitude</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="attitude"
                                                                        className="form-control select2"
                                                                        value={newRecord.attitude}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="A">A</option>
                                                                        <option value="A+">A+</option>
                                                                        <option value="B">B</option>
                                                                        <option value="B+">B+</option>
                                                                        <option value="C">C</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Evaluated By</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="evaluated_by"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.evaluated_by || "EAZYWORLD"}
                                                                        onChange={handleInputChange}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Date</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="evaluated_date"
                                                                        type="date"
                                                                        value={newRecord.evaluated_date || ""} // Use the state variable
                                                                        onChange={(e) => {
                                                                            const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                            setNewRecord(prevState => ({
                                                                                ...prevState,
                                                                                evaluated_date: dateValue // Update state directly
                                                                            }));
                                                                        }}
                                                                        className="form-control"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="modal-footer border-0">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-success"
                                                        >
                                                            Save Changes
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            data-dismiss="modal"
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* View Modal */}
                                <div className="modal fade" id="viewRowModal" tabIndex="-1" role="dialog" aria-hidden="true">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary">
                                                <h5 className="modal-title">View Personal Interaction Evaluation</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleFormSubmit}>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>Name</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.Name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>Training Date</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.training_date}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>Organization</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.organization}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>Batch No</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.batch_no}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 style={{ textAlign: "left" }}>License No</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.LMV_HMV_license_no}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-section">
                                                        <hr></hr>
                                                        <h4>Experience</h4>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Company 1</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.exp_com1}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Years</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.exp_year1}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Company 2</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.exp_com2}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Years</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.exp_year2}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Company 3</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.exp_com3}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Years</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.exp_year3}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Years As Helper</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.years_as_helper}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>years as Operator </h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.years_as_operator}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Minimum Capacity</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.mini_capa}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Maximum Capacity</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.max_capa}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Version Level</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.version_level}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Any Accidents occured</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.accidents_occured}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-section">
                                                        <hr></hr>
                                                        <h4>Area Analyzed</h4>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Safety Systems</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.safety_sys}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.safety_remark}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Work Systems</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.work_safety}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.work_remark}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-section">
                                                        <hr></hr>
                                                        <h4>Understanding Of</h4>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Load Chart</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.loadchart_grade}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.loadchart_remark}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Signals</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.signals_grade}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.signal_remark}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Practical Operation</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.practical_opt_grade}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.practical_opt_remark}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Remark</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.evaluate_remark}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Interaction</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.interaction}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Attentive</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.attentive}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Attitude</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.attitude}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Evaluated By</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.evaluated_by}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h5 style={{ textAlign: "left" }}>Date</h5>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.evaluated_date}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="modal-footer border-0">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            data-dismiss="modal"
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalInteractionEvaluation;
